import { ImageOutlined, PictureAsPdf, ArticleOutlined, GridOnOutlined } from "@mui/icons-material";
import { ListItem, ListItemIcon, ListItemText, useTheme } from "@mui/material";

export type FileListItemType = {
  fileUrl: string
};

export default function FileListItem({ fileUrl } : FileListItemType) {
  const theme = useTheme();
  const first = fileUrl.split('?GoogleAccessId')[0];
  const fileName = first.split('/').pop();
  const fileExtension = fileName.split('.').pop().toLowerCase();
  let icon = <PictureAsPdf />;

  const style = { 
    mb: 2,
    px: 2,
    py: 1,
    backgroundColor: theme.palette.grey[200],
    borderRadius: 1,
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.palette.grey[400],
      cursor: 'pointer'
    }
  };

  if (fileExtension === 'pdf') {
    icon = <PictureAsPdf color="error"/>;
  } else if (fileExtension === 'dwg') {
    icon = <ImageOutlined color="info"/>;
  } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
    icon = <GridOnOutlined color="success"/>;
  } else {
    icon = <ArticleOutlined color="info"/>;
  }

  const openFile = () => window.open(fileUrl);

  return (
    <ListItem sx={style} onClick={openFile}>
      <ListItemIcon>
        {icon}
      </ListItemIcon>
      <ListItemText primary={fileName} />
    </ListItem>
  );
}